var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.460938 4.98438L4.21094 1.23438C4.49219 0.929688 4.98438 0.929688 5.26562 1.23438C5.57031 1.51562 5.57031 2.00781 5.26562 2.28906L2.80469 4.75H10C10.3984 4.75 10.75 5.10156 10.75 5.5C10.75 5.92188 10.3984 6.25 10 6.25H2.80469L5.26562 8.73438C5.57031 9.01562 5.57031 9.50781 5.26562 9.78906C4.98438 10.0938 4.49219 10.0938 4.21094 9.78906L0.460938 6.03906C0.15625 5.75781 0.15625 5.26562 0.460938 4.98438Z",
    fill: "#111113"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/IconArrowLeft.0412ecbd521835abb7ae07855cc50ae3.svg";
export { ForwardRef as ReactComponent };